/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';
import { isValidToken } from '../../../../lib/isValidToken';

function mapStateToRequests(state, ownProps) {
  const token = state.token;

  return {
    subscriber: {
      url: `/subscribers?token=${token}&normalize=true`,
      // Only load this endpoint if we have a valid token
      onLoad: isValidToken(token),
    },
    getSubscriptions: {
      url: `/subscriptions?token=${token}`,
    },
    logout: {
      url: `/logout?token=${token}`,
    }
  };
}

export default connectRequests(mapStateToRequests);
